export const directfulServiceTypes = {
  PlatformAccessFee: 'PlatformAccessFee',
  Marketing: 'Marketing',
  MarketingWithCommission: 'MarketingWithCommission',
  Messaging: 'Messaging'
}

export const directfulServiceNames = {
  CoreServices: 'Directful Core Services',
  PlatformAccessFee: 'Platform access fee',
  Marketing: 'Marketing',
  MarketingWithCommission: 'Marketing with commission',
  Messaging: 'In-property messaging'
}
